import { useSelector } from 'react-redux'
import { getShard } from '~editor/selectors/shard'
import { useMemo } from 'react'
import { getNodesMap } from '~editor/selectors/nodes'
import { buildBlockElements } from '~core/utils/render'
import { ROOT_ID } from '~editor/utils/constants'
import { store } from '~root/src/editor/store'
import { RootState } from '~editor/models'

export const useNewForge = () => {
  const shard = useSelector(getShard)

  return useMemo(() => {
    if (shard?.shard.id) {
      // because we don't want to re-render every time the node tree changes
      const nodes = getNodesMap(store.getState() as RootState)

      return buildBlockElements({
        shardId: shard?.shard.id,
        node: {
          ...nodes[ROOT_ID],
          children: nodes[ROOT_ID].children.slice().reverse(),
        },
        nodes: nodes,
      })
    }
  }, [shard?.shard.id])
}
